import { FormEvent, useMemo, useState } from "react"
import { Link, useNavigate, useSearchParams } from "react-router-dom"
import { loginLocal, setSessionTokens } from "../lib/auth"
import { config } from "../lib/config"

export const LoginPage = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const returnPath = useMemo(() => searchParams.get("return") || "/app", [searchParams])
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault()
    setError(null)
    setLoading(true)
    try {
      const tokens = await loginLocal(email.trim(), password)
      setSessionTokens(tokens.access_token, tokens.refresh_token)
      const mustChange = tokens.usuario?.must_change_password
      if (mustChange) {
        navigate("/app/alterar-senha", { replace: true })
        return
      }
      navigate(returnPath.startsWith("/") ? returnPath : "/app", { replace: true })
    } catch (err) {
      setError(err instanceof Error ? err.message : "Não foi possível entrar. Verifique e-mail e senha.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 shadow-sm"
      >
        <div className="mb-6 text-center">
          <Link to="/" className="inline-flex items-center gap-2" aria-label={`${config.appName} início`}>
            <img src="/assets/brand/logo-horizontal.svg" alt="" className="mx-auto h-9 w-auto" />
          </Link>
          <h1 className="mt-4 text-xl font-semibold text-slate-900">Entrar no {config.appName}</h1>
          <p className="mt-2 text-sm text-slate-600">Use o e-mail e a senha da sua conta para acessar o painel.</p>
        </div>

        <label className="block text-sm font-medium text-slate-700" htmlFor="email">
          E-mail
        </label>
        <input
          id="email"
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/30"
        />

        <div className="mt-4 flex items-center justify-between">
          <label className="block text-sm font-medium text-slate-700" htmlFor="password">
            Senha
          </label>
          <Link to="/esqueci-senha" className="text-sm font-medium text-brand-600 hover:underline">
            Esqueceu a senha?
          </Link>
        </div>
        <input
          id="password"
          type="password"
          autoComplete="current-password"
          required
          minLength={8}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/30"
        />

        {error ? <p className="mt-3 text-sm text-red-600">{error}</p> : null}

        <button
          type="submit"
          disabled={loading}
          className="mt-6 w-full rounded-lg bg-brand-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-brand-700 disabled:opacity-60"
        >
          {loading ? "Entrando…" : "Entrar no painel"}
        </button>

        <p className="mt-4 text-center text-sm text-slate-600">
          Problemas para acessar?{" "}
          <a href={`mailto:${config.supportEmail}`} className="font-medium text-brand-600 hover:underline">
            Fale com o suporte
          </a>
        </p>
      </form>
    </main>
  )
}
